import { css } from 'styled-components';
import colors from '../styles/colors';

const fontColor = (color) => color || colors.base.beta;

const modalContainerStyle = css`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: ${colors.shades.gamma10}80;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const modalStyle = css`
  display: flex;
  flex-direction: column;
  width: 400px;
  background-color: ${colors.base.gamma};
  border-radius: 10px;
  padding: 20px;
`;

const modalButtonContainerStyle = css`
  display: flex;
  align-items: flex-start;
`;

const modalButtonStyle = (color) => css`
  background-color: transparent;
  font-size: 16px;
  color: ${fontColor(color)};
  font-weight: bold;
`;

const modalButtonSecondaryStyle = () => modalButtonStyle(colors.shades.gamma7);
const modalButtonPrimaryStyle = () => modalButtonStyle(colors.base.secondary);

export {
  modalContainerStyle,
  modalStyle,
  modalButtonContainerStyle,
  modalButtonStyle,
  modalButtonSecondaryStyle,
  modalButtonPrimaryStyle,
};
